module.exports = __webpack_public_path__ + "static/media/hidraulica.d178d417.svg";